var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "div",
          [
            _c("pulse-loader", {
              staticStyle: { "text-align": "center" },
              attrs: { loading: _vm.loading, color: _vm.color },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("h5", [_vm._v("Шаблоны рецептов")]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("Врач")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selected_doctor,
                        expression: "selected_doctor",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selected_doctor = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.receipt_docs, function (doc) {
                    return _c("option", { domProps: { value: doc.id } }, [
                      _vm._v(
                        _vm._s(doc.name) +
                          "\n                  " +
                          _vm._s(doc.specialty) +
                          "\n                "
                      ),
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12 text-rigth" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        on: { click: _vm.open_new_doctor },
                      },
                      [_vm._v("Добавить врача")]
                    ),
                    _vm._v(" "),
                    _c(
                      "vue-ladda",
                      {
                        attrs: {
                          "button-class": "btn btn-info",
                          "data-style": "zoom-in",
                          loading: _vm.submit_doctor_loading,
                        },
                        on: { click: _vm.readDoctor },
                      },
                      [_vm._v("Показать врача\n                ")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("Шаблон")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selected_template,
                        expression: "selected_template",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selected_template = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.receipt_templates, function (doc) {
                    return _c("option", { domProps: { value: doc.id } }, [
                      _vm._v(_vm._s(doc.title) + "\n                "),
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12 text-rigth" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        on: { click: _vm.open_new_template },
                      },
                      [_vm._v("Создать шаблон")]
                    ),
                    _vm._v(" "),
                    _c(
                      "vue-ladda",
                      {
                        attrs: {
                          "button-class": "btn btn-info",
                          "data-style": "zoom-in",
                          loading: _vm.submit_form_loading,
                        },
                        on: { click: _vm.readTemplate },
                      },
                      [_vm._v("Показать шаблон\n                ")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.show_new_doctor_div
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("h5", [_vm._v("Редактирование врача")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-5" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [_vm._v("Имя врача")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|min:3|max:255",
                                expression: "'required|min:3|max:255'",
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.new_doctor_name,
                                expression: "new_doctor_name",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              name: "new_doctor_name_field",
                              placeholder: "Имя врача",
                              "data-vv-as": "Имя врача",
                            },
                            domProps: { value: _vm.new_doctor_name },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.new_doctor_name = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.errors.has("new_doctor_name_field")
                            ? _c(
                                "small",
                                { staticClass: "form-text text-danger" },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "new_doctor_name_field"
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [
                            _vm._v("Имя врача на английском языке"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|min:3|max:255",
                                expression: "'required|min:3|max:255'",
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.new_eng_doctor_name,
                                expression: "new_eng_doctor_name",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              name: "new_eng_doctor_name_field",
                              placeholder: "Имя врача на английском языке",
                              "data-vv-as": "Имя врача на английском языке",
                            },
                            domProps: { value: _vm.new_eng_doctor_name },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.new_eng_doctor_name = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.errors.has("new_eng_doctor_name_field")
                            ? _c(
                                "small",
                                { staticClass: "form-text text-danger" },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "new_eng_doctor_name_field"
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-5" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [_vm._v("Специальность врача")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|min:3|max:255",
                                expression: "'required|min:3|max:255'",
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.new_doctor_specialty,
                                expression: "new_doctor_specialty",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              name: "new_doctor_specialty_field",
                              placeholder: "Специальность врача",
                              "data-vv-as": "Специальность врача",
                            },
                            domProps: { value: _vm.new_doctor_specialty },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.new_doctor_specialty = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.errors.has("new_doctor_specialty_field")
                            ? _c(
                                "small",
                                { staticClass: "form-text text-danger" },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "new_doctor_specialty_field"
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [
                            _vm._v("Специальность врача на английском языке"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|min:3|max:255",
                                expression: "'required|min:3|max:255'",
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.new_eng_doctor_specialty,
                                expression: "new_eng_doctor_specialty",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              name: "new_eng_doctor_specialty_field",
                              placeholder:
                                "Специальность врача на английском языке",
                              "data-vv-as":
                                "Специальность врача на английском языке",
                            },
                            domProps: { value: _vm.new_eng_doctor_specialty },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.new_eng_doctor_specialty =
                                  $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.errors.has("new_eng_doctor_specialty_field")
                            ? _c(
                                "small",
                                { staticClass: "form-text text-danger" },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "new_eng_doctor_specialty_field"
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-2 action_btns" },
                        [
                          _c(
                            "vue-ladda",
                            {
                              attrs: {
                                "button-class": "btn btn-danger",
                                "data-style": "zoom-in",
                                loading: _vm.submit_delete_doctor_loading,
                              },
                              on: { click: _vm.deleteDoc },
                            },
                            [_vm._v("Удалить\n                  ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "vue-ladda",
                            {
                              attrs: {
                                "button-class": "btn btn-info",
                                "data-style": "zoom-in",
                                loading: _vm.submit_save_doctor_loading,
                              },
                              on: { click: _vm.setDefaultDoc },
                            },
                            [_vm._v("По умолчанию\n                  ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "vue-ladda",
                            {
                              attrs: {
                                "button-class": "btn btn-success",
                                "data-style": "zoom-in",
                                loading: _vm.submit_save_doctor_loading,
                              },
                              on: { click: _vm.saveNewDoc },
                            },
                            [_vm._v("Сохранить\n                  ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.show_new_template_div
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("h5", [_vm._v("Новый шаблон")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|min:1|max:255",
                          expression: "'required|min:1|max:255'",
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.templateUploadTitle,
                          expression: "templateUploadTitle",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        name: "templateUploadTitle_name",
                        placeholder: "Название шаблона",
                        "data-vv-as": "Название шаблона",
                      },
                      domProps: { value: _vm.templateUploadTitle },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.templateUploadTitle = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.has("templateUploadTitle_name")
                      ? _c("small", { staticClass: "form-text text-danger" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.errors.first("templateUploadTitle_name")
                              ) +
                              "\n              "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "btn-group p-t-10" },
                      [
                        _c(
                          "file-upload",
                          {
                            ref: "upload_new",
                            staticClass: "btn btn-info",
                            attrs: {
                              extensions: "docx",
                              accept:
                                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                              multiple: false,
                              size: 1024 * 1024 * 10,
                            },
                            on: {
                              "input-filter": _vm.inputFilter,
                              "input-file": _vm.inputFile,
                            },
                            model: {
                              value: _vm.file_new,
                              callback: function ($$v) {
                                _vm.file_new = $$v
                              },
                              expression: "file_new",
                            },
                          },
                          [
                            _c("i", { staticClass: "fa fa-plus" }),
                            _vm._v(
                              "\n                  Выберите шаблон\n                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.file_new, function (n_file, index) {
                          return _c(
                            "div",
                            { key: n_file.id, staticClass: "file_info" },
                            [
                              _c("span", [_vm._v(_vm._s(n_file.name))]),
                              _vm._v(" -\n                  "),
                              _c("span", [_vm._v(_vm._s(n_file.size))]),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.file_new &&
                        (!_vm.$refs.upload_new || !_vm.$refs.upload_new.active)
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-success",
                                attrs: { type: "button" },
                                on: { click: _vm.customUpload },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-arrow-up",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v(
                                  "\n                  Загрузить\n                "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.display_template
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-8" }, [
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.display_template) },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-12 text-rigth flex template_btns",
                        },
                        [
                          _c(
                            "vue-ladda",
                            {
                              attrs: {
                                "button-class": "btn btn-danger m-r-40",
                                "data-style": "zoom-in",
                                loading: _vm.submit_delete_doctor_loading,
                              },
                              on: { click: _vm.deleteTemplate },
                            },
                            [_vm._v("Удалить шаблон\n                  ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "btn-group" },
                            [
                              _c(
                                "file-upload",
                                {
                                  ref: "upload",
                                  staticClass: "btn btn-info",
                                  attrs: {
                                    "post-action": "ttt",
                                    extensions: "docx",
                                    accept:
                                      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                    multiple: false,
                                    size: 1024 * 1024 * 10,
                                  },
                                  on: {
                                    "input-filter": _vm.inputFilter,
                                    "input-file": _vm.inputFile,
                                  },
                                  model: {
                                    value: _vm.files,
                                    callback: function ($$v) {
                                      _vm.files = $$v
                                    },
                                    expression: "files",
                                  },
                                },
                                [
                                  _c("i", { staticClass: "fa fa-plus" }),
                                  _vm._v(
                                    "\n                      Выберите шаблон\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.files, function (file, index) {
                                return _c(
                                  "div",
                                  { key: file.id, staticClass: "file_info" },
                                  [
                                    _c("span", [_vm._v(_vm._s(file.name))]),
                                    _vm._v(" -\n                      "),
                                    _c("span", [_vm._v(_vm._s(file.size))]),
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _vm.files &&
                              (!_vm.$refs.upload || !_vm.$refs.upload.active)
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-success",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          _vm.$refs.upload.active = true
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-arrow-up",
                                        attrs: { "aria-hidden": "true" },
                                      }),
                                      _vm._v(
                                        "\n                      Загрузить\n                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-success m-r-10",
                              on: { click: _vm.downloadTemplate },
                            },
                            [_vm._v("Скачать шаблон\n                  ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "vue-ladda",
                            {
                              attrs: {
                                "button-class": "btn btn-info",
                                "data-style": "zoom-in",
                                loading: _vm.submit_save_doctor_loading,
                              },
                              on: { click: _vm.setDefaultDocument },
                            },
                            [_vm._v("По умолчанию\n                  ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm._m(0),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-4" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body template_legend" }, [
          _c("p", [
            _c("strong", [_vm._v("${receipt}")]),
            _vm._v(
              " - блок (который будет копироваться в зависимости от\n                количества препаратов в рецепте)"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${break_lines}")]),
            _vm._v(" - разрыв страницы"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${/receipt}")]),
            _vm._v(" - закрытие блока"),
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("${date}")]), _vm._v(" - дата")]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${receipt_number}")]),
            _vm._v(" – номер рецепта"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${card_number}")]),
            _vm._v(" – номер амбулаторной карты"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${doctor_name}")]),
            _vm._v(" – имя врача"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${doctor_name_eng}")]),
            _vm._v(" – имя врача на английском"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${doctor_speciality}")]),
            _vm._v(" – специальность врача"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${doctor_speciality_eng}")]),
            _vm._v(" - специальность врача на английском"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${name}")]),
            _vm._v(" – имя пациента"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${surname}")]),
            _vm._v(" – фамилия пациента"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${fathersname}")]),
            _vm._v(" – отчество пациента"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${initials}")]),
            _vm._v(" – инициалы пациента (Имя, Отчество)"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${name_eng}")]),
            _vm._v(" – имя пациента на английском"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${surname_eng}")]),
            _vm._v(" – фамилия пациента на английском"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${fathersname_eng}")]),
            _vm._v(" – отчество пациента на английском"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${initials_eng}")]),
            _vm._v(
              " – инициалы пациента на английском (Имя,\n                Отчество)\n              "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${birthdate}")]),
            _vm._v(" – дата рождения пациента"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${age}")]),
            _vm._v(" – возраст пациента"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${prep_use_signa}")]),
            _vm._v(" – Применение (Signa)"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${prep_name_lt}")]),
            _vm._v(" – Название препарата на латыни"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${prep_quntity}")]),
            _vm._v(" – количество упаковок"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${prep_use_days}")]),
            _vm._v(" – на сколько дней рецепт"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${box_boxes}")]),
            _vm._v(
              " – одна упаковка или (множественное число) - box/boxes (зависит от\n                ${prep_quntity})"
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${address_type}")]),
            _vm._v(" – тип адреса (улица, проспек, переулок ...)"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${address_name}")]),
            _vm._v(" – адрес"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${address_house}")]),
            _vm._v(" – номер дома"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${address_flat}")]),
            _vm._v(" – квартира, если есть (кв. ХХХ)"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${address_type_en}")]),
            _vm._v(" – ENG тип адреса (улица, проспек, переулок ...)"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${address_name_en}")]),
            _vm._v(" – ENG адрес"),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("${address_flat_en}")]),
            _vm._v(" – ENG квартира, если есть (flat ХХХ)"),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }